import React from "react";
import resumePDF from "../assets/Mohamed Shaheen cv.pdf";

const Resume = () => {
  const isDarkMode = document.body.classList.contains("dark");

  return (
    <div
      className={`min-h-screen flex flex-col justify-start items-center p-8 ${
        isDarkMode ? "bg-[#111827] text-white" : "bg-white text-gray-900"
      }`}
    >
      <div className="container mx-auto px-6 md:px-12">
        <h1 className="text-5xl font-bold text-center mb-12">
          My Resume
        </h1>

        <div className="flex justify-center gap-6">
          {/* View Button */}
          <a
            href={resumePDF}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gray-700 text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition"
          >
            View Resume
          </a>

          {/* Download Button */}
          <a
            href={resumePDF}
            download="Mohamed_Shaheen_Resume.pdf"
            className="bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition"
          >
            Download Resume
          </a>
        </div>
      </div>
    </div>
  );
};

export default Resume;
